/**
 * Control Room → Logg (sak 238, trinn 2): `GET /v1/platform/activity`.
 *
 * Plattformloggen (`app.platform_activity_log`, 0477): hva plattformadminene har gjort i Control
 * Room — hvem, hva, hvilken organisasjon og detaljer. Nyeste først, blas med markør på
 * (tidspunkt, id). `action` er `<område>.<verb>`, f.eks. `platform_admin.added`; weben oversetter
 * den under `controlRoom.log.actions.*` og viser koden selv når det ikke finnes en tekst.
 */
import { z } from 'zod';

import { DEFAULT_PAGE_SIZE, MAX_CURSOR_LENGTH, MAX_PAGE_SIZE, page } from '../http/pagination.js';

export const platformActivityEntrySchema = z
  .object({
    id: z.uuid(),
    occurredAt: z.iso.datetime(),
    actorUserId: z.uuid(),
    actorEmail: z.string(),
    action: z.string(),
    organizationId: z.uuid().nullable(),
    organizationName: z.string().nullable(),
    details: z.record(z.string(), z.unknown()),
  })
  .meta({ id: 'PlatformActivityEntry' });

export const platformActivityListResponseSchema = page(
  platformActivityEntrySchema,
  'PlatformActivityListResponse',
);

export const listPlatformActivityQuerySchema = z
  .object({
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    cursor: z.string().max(MAX_CURSOR_LENGTH).optional(),
  })
  .meta({ id: 'ListPlatformActivityQuery' });

export type PlatformActivityEntry = z.infer<typeof platformActivityEntrySchema>;
export type PlatformActivityListResponse = z.infer<typeof platformActivityListResponseSchema>;
export type ListPlatformActivityQuery = z.infer<typeof listPlatformActivityQuerySchema>;
